// extracted by mini-css-extract-plugin
export default {"root":"BlockChainLabel_root__moteI","stripes-animation-background-keyframes":"BlockChainLabel_stripes-animation-background-keyframes__XCvn6"};